import { round } from 'lodash-es'
import { NameType, Payload, ValueType } from 'recharts/types/component/DefaultTooltipContent'

import { Text } from '@infura/packages.ui/Text'

import {
  THRESHOLD_NAMES,
  ThresholdName
} from 'components/dashboard/analytics-overview/DailyCreditUsageChart/DailyCreditUsageChart'

import { CHART_COLORS } from 'lib/constants'

export const TOOLTIP_TEST_ID = 'tooltip-content'

export type TooltipState = {
  payload?: Array<Payload<ValueType, NameType>>
  show: boolean
  x: number
  y: number
}

interface TooltipContentProps {
  payload: Array<Payload<ValueType, NameType>>
  focusSeries: string | null
  isUsageEnabled?: boolean
}

const focusSeriesMap = {
  eightyFivePercent: '85%',
  seventyFivePercent: '75%'
} satisfies { [key in ThresholdName]: string }

export const TooltipContent = ({ focusSeries, isUsageEnabled, payload }: TooltipContentProps) => {
  const totalCUs = payload.reduce((acc, { dataKey, value }) => {
    if (!!dataKey && THRESHOLD_NAMES.includes(dataKey as ThresholdName)) {
      return acc
    }
    return acc + Number(value ?? 0)
  }, 0)
  return (
    <div
      className='shadow-tooltip bg-icon-default text-info-inverse pointer-events-auto space-y-4 rounded-[5px] p-4'
      data-testid={TOOLTIP_TEST_ID}
    >
      {focusSeries && THRESHOLD_NAMES.includes(focusSeries as ThresholdName) ? (
        <div className='max-w-[256px]'>
          <Text className='!text-info-inverse'>
            When you reach <span> {focusSeriesMap[focusSeries]} </span> of your total allotted credit quota for the day
            you will receive an email notification.
          </Text>
        </div>
      ) : (
        <>
          <table className='pb-4'>
            <tbody>
              {payload.map(({ color, dataKey, value }) => {
                if (!Number(value ?? 0) || (!!dataKey && THRESHOLD_NAMES.includes(dataKey as ThresholdName))) {
                  return null
                }
                return (
                  <tr key={`tooltip-${dataKey}`}>
                    <td className='py-1 pl-0'>
                      <div className='!text-info-inverse flex items-center gap-2'>
                        <div
                          className='h-4 w-4 rounded-sm'
                          style={{ backgroundColor: dataKey === 'All Other' ? CHART_COLORS.at(-1) : color }}
                        />
                        {dataKey}
                      </div>
                    </td>
                    <td className='!text-info-inverse py-1'>{value?.toLocaleString()}</td>
                    <td className='!text-info-inverse py-1'>{round((Number(value) / totalCUs) * 100, 2)} %</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <div className='border-border-muted border-t pt-4'>
            <span className='font-bold'>Total </span>
            <span>{totalCUs.toLocaleString()} </span>
            <span>{isUsageEnabled ? 'Credits' : 'Requests'}</span>
          </div>
        </>
      )}
    </div>
  )
}
